import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

// 模块
// 报刊亭
import * as newsKiosk from './modules/newsKiosk'
// 用户权限
import * as user from './modules/user'

export default new Vuex.Store({
  state: {},
  mutations: {},
  actions: {},
  modules: {
    newsKiosk,
    user
  }
})
